<template>
  <InertiaHead>
    <title>Make Smarter Decisions Now</title>
    <meta
      name="description"
      content="Assemble AI specialist teams that debate, challenge assumptions, and refine solutions together—delivering perspectives no single AI can provide."
    />
    <link rel="canonical" href="https://vibeteams.ai/" />
  </InertiaHead>

  <div class="welcome-page min-h-screen">
    <Navbar></Navbar>
    <main class="space-y-20 pb-20 md:space-y-40">
      <!-- Main Hero Section -->
      <HeroSection></HeroSection>

      <!-- Use Case Section -->
      <UseCase></UseCase>

      <!-- Vibe With Us Section -->
      <VibeWithUs></VibeWithUs>

      <!-- Dream Team Steps -->
      <DreamSteps></DreamSteps>

      <!-- Choosing your Vibe -->
      <ChooseVibe :plans="plans"></ChooseVibe>

      <!-- Vibe Begin -->
      <VibeBegin></VibeBegin>
    </main>
    <NavFooter></NavFooter>
  </div>
</template>

<script lang="ts">
import NavFooter from '@/components/landing/Footer.vue';
import Navbar from '@/components/landing/Navbar.vue';

import ChooseVibe from '@/components/landing/ChooseVibe.vue';
import DreamSteps from '@/components/landing/DreamSteps.vue';
import HeroSection from '@/components/landing/HeroSection.vue';
import UseCase from '@/components/landing/UseCase.vue';
import VibeBegin from '@/components/landing/VibeBegin.vue';
import VibeWithUs from '@/components/landing/VibeWithUs.vue';
import { Head as InertiaHead } from '@inertiajs/vue3';
export default {
  name: 'WelcomePage',
  components: {
    InertiaHead,
    NavFooter,
    Navbar,
    HeroSection,
    UseCase,
    VibeWithUs,
    DreamSteps,
    ChooseVibe,
    VibeBegin,
  },
  props: {
    plans: {
      type: Array,
      required: true,
    },
  },
  mounted() {
    const isMobile = window.matchMedia('(max-width: 1023px)').matches;

    if (isMobile) {
      // Use Intersection Observer to defer swiper registration until needed
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              import('swiper/element-bundle').then(({ register }) => {
                register();
              });
              observer.disconnect();
            }
          });
        },
        { rootMargin: '100px' },
      ); // Start loading 100px before element is visible

      // Observe the first swiper container
      const swiperElement = document.querySelector('swiper-container');
      if (swiperElement) {
        observer.observe(swiperElement);
      }
    }
  },
};
</script>
